import { Heading, Text } from '@podiumhq/design-system';
import { useCheckoutContext } from 'contexts/CheckoutContextProvider';

export const CheckoutTitle = ({ children, sx = {}, ...props }) => {
  const { isMobile } = useCheckoutContext() || {};
  const titleSx = { fontSize: isMobile ? '24px' : '40px', ...sx };

  return (
    <Heading
      fontSize="3xl"
      fontWeight="semibold"
      mb="8px"
      sx={titleSx}
      {...props}
    >
      {children}
    </Heading>
  );
};

export const CheckoutDescription = ({ children, ...props }) => {
  const { isMobile } = useCheckoutContext() || {};

  return (
    <Text fontSize={isMobile ? 'md' : 'lg'} fontWeight="normal" {...props}>
      {children}
    </Text>
  );
};
